import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { fetchOrganisationById, fetchOrganisations } from '../../predict/src/core/api/organisations';
import { queryClient } from '../core/queryClient';

type FetchOrganisationByIdResult = Awaited<ReturnType<typeof fetchOrganisationById>>;
type FetchOrganisationsResult = Awaited<ReturnType<typeof fetchOrganisations>>;
type Options = Omit<QueryObserverOptions<FetchOrganisationByIdResult>, 'queryKey' | 'queryFn'>;
type OrganisationsQueryOptions = Omit<QueryObserverOptions<FetchOrganisationsResult>, 'queryKey' | 'queryFn'>;

export const organisationQueryKey = (organisationId: string, workspaceId: string) => [
  'organisation',
  organisationId,
  workspaceId
];

export const organisationQuery = (
  workspaceId: string,
  organisationId: string,
  options?: Options
): QueryObserver<FetchOrganisationByIdResult> =>
  new QueryObserver<FetchOrganisationByIdResult>(queryClient, {
    queryKey: organisationQueryKey(organisationId, workspaceId),
    queryFn: () => fetchOrganisationById(workspaceId, organisationId),
    ...options
  });

export const organisationsQueryKey = (workspaceId: string) => ['organisations', workspaceId];

export const organisationsQuery = (
  workspaceId: string,
  options?: OrganisationsQueryOptions
): QueryObserver<FetchOrganisationsResult> =>
  new QueryObserver<FetchOrganisationsResult>(queryClient, {
    queryKey: organisationsQueryKey(workspaceId),
    queryFn: () => fetchOrganisations(workspaceId),
    ...options
  });

export const clearOrganisationsQueryCache = (workspaceId: string): void => {
  queryClient.invalidateQueries({ queryKey: organisationsQueryKey(workspaceId) });
};
